<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled,
      'nav-item--report-locked': isNavReportLocked,
    }"
  >
    <!-- Trava de report pendente: cadeado e sem navegação (exceto Compromissos) — mixinReportLockedNavItem -->
    <b-link
      v-bind="linkProps"
      :disabled="isNavReportLocked"
      :title="navReportLockedHint"
      class="d-flex align-items-center"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="resolvedTag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ resolvedTag }}
      </b-badge>
      <transition name="nav-report-lock">
        <feather-icon
          v-if="isNavReportLocked"
          icon="LockIcon"
          size="14"
          class="nav-report-lock-icon"
          aria-hidden="true"
        />
      </transition>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'
import mixinReportLockedNavItem from '../../mixinReportLockedNavItem'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink, mixinReportLockedNavItem],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // `tagGetter` (nome de getter do Vuex) permite badge dinâmico, ex.: não lidas do chat.
    resolvedTag() {
      if (this.item.tagGetter) return this.$store.getters[this.item.tagGetter] || null
      return this.item.tag
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>
